import moment from 'moment';
import styled from 'styled-components';
import themeGet from '@styled-system/theme-get';
import { Paragraph } from '../../../../shared/TableComponents/StyledComponents';

const DateCell = styled(Paragraph)`
  text-align: right;
  cursor: pointer;
  color: ${themeGet('colors.primary.100')};

  &:hover {
    color: ${themeGet('colors.primary.80')};
  }

  &:active {
    color: ${themeGet('colors.primary.120')};
  }
`;

const EditDateCell = ({ date, showModal }) => {
  return date ? (
    <DateCell onClick={showModal}>{moment(date).format('M/D/YY')}</DateCell>
  ) : (
    <DateCell emptyDate={'true'} onClick={showModal}>
      Add Date
    </DateCell>
  );
};

export default EditDateCell;
